import ReactPixel from "react-facebook-pixel";

const PIXEL_ID = "1358922126215385";

export const isLocalDev =
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");

let initialized = false;

export const initFacebookPixel = () => {
  if (initialized || typeof window === "undefined") return;

  ReactPixel.init(PIXEL_ID, undefined, {
    autoConfig: true,
    debug: isLocalDev || process.env.NODE_ENV === "development",
  });

  initialized = true;
  ReactPixel.pageView();

  if (isLocalDev) {
    window.setTimeout(() => {
      const scriptLoaded = [...document.scripts].some((script) => script.src.includes("fbevents.js"));

      if (!scriptLoaded) {
        console.warn(
          "[fbPixel] fbevents.js did not load (net::ERR_BLOCKED_BY_CLIENT). " +
            "Disable your ad blocker / Brave Shields for localhost to test with Meta Pixel Helper.",
        );
      }
    }, 2000);
  }
};

export const isFacebookPixelReady = () => initialized;

export const trackFacebookPageView = () => {
  if (!initialized) return;
  ReactPixel.pageView();
};

export default ReactPixel;
